<template>
  <div class="detail" :class="{ 'detail--dark': darkMode }">
    <div class="detail__head">
      <video
        class="detail__video"
        id="video"
        v-if="isVideo && headImg"
        :src="headImg"
        :poster="poster"
        loop
        @click="videoClick"
      ></video>
      <div
        class="detail__img"
        v-else-if="headImg"
        :style="'background-image: url(' + headImg + ');'"
      ></div>
      <div class="detail__text" v-if="!isVideo">
        <div class="detail__title">{{ title }}</div>
        <div class="detail__time">{{ time }}</div>
      </div>
      <img
        v-if="pauseVideo"
        class="detail__videopause"
        src="https://subscribe-prod-oss.oss-cn-hangzhou.aliyuncs.com/miniapp-ico/icon/button-play%403x-new.png"
      />
    </div>
    <div style="font-size: 12px" class="webview" v-html="html"></div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import api from "../api";
const route = useRoute();
const newsId = route.query.id;
let html = ref("");
const darkMode = ref(false);
if (route.query && route.query.mode === "dark") {
  darkMode.value = true;
}
const headImg = ref(""); // 头部图片/视频地址
const poster = ref(""); // 封面图片
const title = ref(""); // 头部显示的标题
const time = ref(""); // 头部显示的时间
const isVideo = ref(false); // 是否为视频
const pauseVideo = ref(false); // 视频是否被暂停
const videoClick = () => {
  const dom = document.getElementById("video");
  if (pauseVideo.value) {
    dom.play();
  } else {
    dom.pause();
  }
  pauseVideo.value = !pauseVideo.value;
};
api.get("/news/" + newsId).then(
  (res) => {
    if (res.status === 200 && res.data.code === "0") {
      // document.querySelector("title").innerHTML = res.data.body.name;
      html.value = res.data.body.newsDetails;
      headImg.value = res.data.body.coverUrl;
      poster.value = res.data.body.contentHeadImage;
      title.value = res.data.body.title;
      time.value = res.data.body.createdTime;
      isVideo.value =
        res.data.body.coverUrl && res.data.body.coverUrl.indexOf(".mp4") != -1;
      if (isVideo.value) {
        pauseVideo.value = true;
      }
    } else {
      html.value = "获取内容失败";
    }
  },
  () => {
    html.value = "获取内容失败";
  }
);
// 421459faa4e1f6d564f67d138620be8d为“极氪订阅”的md5字符串
// if (
//   (route.query && route.query.token === "421459faa4e1f6d564f67d138620be8d") ||
//   /\/public\/TK002/i.test(route.fullPath)
// ) {

// } else {
//   html.value = "您无权限查看";
// }
</script>
<style scoped>
.detail {
  width: 100%;
  height: 100%;
  overflow: auto;
  font-family: PingFangSC-Regular, sans-serif;
}
::v-deep * {
  margin: 0;
  font-size: 30px;
}
.webview {
  padding: 30px;
  box-sizing: border-box;
}
.detail--dark {
  background: #0b0b0b;
  color: #fff;
}
::v-deep img {
  max-width: 100%;
}
.detail__head {
  position: relative;
  height: 750px;
}
.detail__video,
.detail__img {
  position: absolute;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.detail__title {
  font-size: 20px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgba(221, 221, 221, 1);
  font-size: 20px;
  font-weight: 600;
}
.detail__text {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
  background: linear-gradient(0deg, #0b0b0b, rgba(36, 41, 43, 0));
}
.detail__time {
  display: block;
  margin-top: 10px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(157, 162, 165, 1);
}
.detail__videopause {
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 120px;
  height: 120px;
}
</style>
